import { App } from 'vue'
import Blueprint from './LpBlueprint.vue'

Blueprint.install = (Vue: App) => {
  Vue.component(Blueprint.name, Blueprint)
}

export default Blueprint
